import { HTMLAttributes, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type ICardContentProps = HTMLAttributes<HTMLDivElement>;

export function CardContent({
  children,
  className,
  ...rest
}: PropsWithChildren<ICardContentProps>) {
  return (
    <div className={twMerge('', className)} {...rest}>
      {children}
    </div>
  );
}
